var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "menu-position" }, [
    _c("div", { staticClass: "tools-strip" }, [
      _vm.globalIsUserAllowed("Change_Extent_Widget")
        ? _c(
            "button",
            {
              staticClass: "tool-btn",
              class: { "tool-btn--active": _vm.activePanel === "extents" },
              attrs: { title: "Change Extent" },
              on: {
                click: function ($event) {
                  return _vm.togglePanel("extents")
                },
              },
            },
            [
              _c("fa", {
                attrs: { icon: ["fas", "globe-americas"], size: "sm" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.globalIsUserAllowed("Base_Map_Widget")
        ? _c(
            "button",
            {
              staticClass: "tool-btn",
              class: { "tool-btn--active": _vm.activePanel === "base" },
              attrs: { title: "Base Maps" },
              on: {
                click: function ($event) {
                  return _vm.togglePanel("base")
                },
              },
            },
            [_c("fa", { attrs: { icon: ["fas", "map"], size: "sm" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.globalIsUserAllowed("2D_Lidar") &&
      (_vm.ansiComponent ||
        _vm.drtComponents ||
        _vm.analyticsVisible ||
        _vm.wclVisible)
        ? _c(
            "button",
            {
              staticClass: "tool-btn",
              class: {
                "tool-btn--active": _vm.showLidarPanel,
                "tool-btn--warn": !_vm.lidarMinZoomAchieved,
              },
              attrs: { title: "2D Lidar" },
              on: { click: _vm.toggleLidar },
            },
            [
              _c("fa", {
                attrs: {
                  icon: [
                    "fas",
                    _vm.lidarMinZoomAchieved
                      ? "layer-group"
                      : "exclamation-triangle",
                  ],
                  size: "sm",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.globalIsUserAllowed("Measure_Widget") &&
      (_vm.ansiComponent ||
        _vm.drtComponents ||
        _vm.analyticsVisible ||
        _vm.wclVisible)
        ? _c(
            "button",
            {
              staticClass: "tool-btn",
              class: { "tool-btn--active": _vm.measuringToolOn },
              attrs: { title: "Measuring Tool" },
              on: { click: _vm.toggleMeasure },
            },
            [_c("fa", { attrs: { icon: ["fas", "ruler"], size: "sm" } })],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tools-popup-area" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activePanel === "zoom",
              expression: "activePanel === 'zoom'",
            },
          ],
          staticClass: "tools-popup",
        },
        [
          _c("MMP_ExpandableDisplay", {
            ref: "updateZoom",
            attrs: {
              collapsedComponent: "zoom",
              map: _vm.map,
              zoomLevel: _vm.zoomLevel,
            },
            on: {
              zoomLevelChanged: function ($event) {
                return _vm.$emit("zoomLevelChanged", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activePanel === "coordinates",
              expression: "activePanel === 'coordinates'",
            },
          ],
          staticClass: "tools-popup",
        },
        [
          _c("MMP_ExpandableDisplay", {
            ref: "updateClickCoords",
            attrs: {
              collapsedComponent: "coordinates",
              map: _vm.map,
              pointVectorSource: _vm.pointVectorSource,
              ansiComponent: _vm.ansiComponent,
              drtComponents: _vm.drtComponents,
              showToggle: _vm.showToggle,
            },
            on: {
              addPoint: function ($event) {
                return _vm.$emit("addPoint", $event)
              },
              showToggle: function ($event) {
                return _vm.$emit("showToggle")
              },
              getVectorlayer: function ($event) {
                return _vm.$emit("getVectorlayer", $event)
              },
              toggleChange: function ($event) {
                return _vm.$emit("toggleChange", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activePanel === "extents",
              expression: "activePanel === 'extents'",
            },
          ],
          staticClass: "tools-popup",
        },
        [
          _c("MMP_ExpandableDisplay", {
            ref: "updateExtent",
            attrs: {
              collapsedComponent: "extents",
              homeScreenComponents: _vm.homeScreenComponents,
              map: _vm.map,
              selectedExtent: _vm.selectedExtent,
              userOrg: _vm.user.org,
              baseMapsOpen: _vm.baseMapsOpen,
              analyticsVisible: _vm.analyticsVisible,
            },
            on: {
              extentsExpandChange: function ($event) {
                return _vm.$emit("extentsExpandChange", $event)
              },
              extentChanged: function ($event) {
                return _vm.$emit("extentChanged", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activePanel === "base",
              expression: "activePanel === 'base'",
            },
          ],
          staticClass: "tools-popup",
        },
        [
          _c("MMP_ExpandableDisplay", {
            ref: "updateBase",
            attrs: {
              collapsedComponent: "base",
              currentBaseMap: _vm.currentBaseMap,
              map: _vm.map,
              isAnsiComponent: _vm.ansiComponent,
              extentsOpen: _vm.extentsOpen,
              showLidarPanel: _vm.showLidarPanel,
            },
            on: {
              baseMapsExpandChange: function ($event) {
                return _vm.$emit("baseMapsExpandChange", $event)
              },
              toggleBaseLayer: function ($event) {
                return _vm.$emit("toggleBaseLayer", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.measuringToolOn,
              expression: "measuringToolOn",
            },
          ],
          staticClass: "tools-popup",
        },
        [
          _c("MMP_Measurement", {
            attrs: {
              showMeasuringTool: _vm.measuringToolOn,
              measurement: _vm.measurement,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLidarPanel,
              expression: "showLidarPanel",
            },
          ],
          staticClass: "lidar-popup",
        },
        [
          _c("MMP_LidarTiles", {
            attrs: {
              showLidarPanel: _vm.showLidarPanel,
              lidarMinZoomAchieved: _vm.lidarMinZoomAchieved,
              distinct_lidar: _vm.distinct_lidar,
              lidarIsLoading: _vm.lidarIsLoading,
              map: _vm.map,
              selectedExtent: _vm.selectedExtent,
              zoomLevel: _vm.zoomLevel,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }